import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

// Auth
export const authRegister = (data) => api.post('/auth/register', data);
export const authLogin = (data) => api.post('/auth/login', data);
export const authLogout = () => api.post('/auth/logout');
export const authMe = () => api.get('/auth/me');
export const authGoogle = (data) => api.post('/auth/google', data);
export const authRefresh = () => api.post('/auth/refresh');
export const updateProfile = (data) => api.put('/auth/profile', data);
export const changePassword = (data) => api.post('/auth/change-password', data);

// User features
export const getAddresses = () => api.get('/user/addresses');
export const addAddress = (data) => api.post('/user/addresses', data);
export const deleteAddress = (id) => api.delete(`/user/addresses/${id}`);
export const getWishlist = () => api.get('/user/wishlist');
export const addToWishlist = (productId) => api.post('/user/wishlist', { product_id: productId });
export const removeFromWishlist = (productId) => api.delete(`/user/wishlist/${productId}`);
export const getUserOrders = () => api.get('/user/orders');
export const getRecentlyViewed = () => api.get('/user/recently-viewed');
export const addRecentlyViewed = (productId) => api.post(`/user/recently-viewed/${productId}`);

// Categories
export const getCategories = () => api.get('/categories');
export const getCategory = (slug) => api.get(`/categories/${slug}`);

// Products
export const getProducts = (params) => api.get('/products', { params });
export const getProduct = (slug) => api.get(`/products/${slug}`);
export const createProduct = (data) => api.post('/products', data);
export const updateProduct = (id, data) => api.put(`/products/${id}`, data);
export const deleteProduct = (id) => api.delete(`/products/${id}`);

// Reviews
export const getReviews = (productId) => api.get(`/reviews/${productId}`);
export const createReview = (data) => api.post('/reviews', data);

// Orders
export const createOrder = (data) => api.post('/orders', data);
export const getOrder = (id) => api.get(`/orders/${id}`);
export const getOrders = (params) => api.get('/orders', { params });
export const updateOrderStatus = (id, status) => api.put(`/orders/${id}/status`, null, { params: { status } });

// Checkout - Square
export const processPayment = (data) => api.post('/process-payment', data);

// Order Tracking
export const trackOrder = (data) => api.post('/orders/track', data);
export const getOrderTracking = (orderId) => api.get(`/orders/${orderId}/tracking`);

// Product filters
export const getPriceRange = (params) => api.get('/products/price-range', { params });

// Contact
export const submitContact = (data) => api.post('/contact', data);
export const getContactMessages = () => api.get('/contact');

// Admin
export const getAdminStats = () => api.get('/admin/stats');

export default api;
